<!--
  * 用户控制，包裹组件，根据用户显示组件，无权限时显示 noPermContent 内容
-->
<template>
  <template v-if="hasPermU(u)">
    <slot></slot>
  </template>
  <template v-else>
    <slot name="noPermContent"></slot>
  </template>
</template>
<script setup lang="ts">
import { hasPermU } from '@/utils/permission';

defineProps<{
  u: number | number[];
}>();
</script>
